import { useUser } from "@/app/context/UserContext";
import React from "react";

const Citations = ({ documents }:{documents:any[]}) => {
  const { user, setUser, userProject,setUserProject, myDocs, setMyDocs } = useUser();// Accedemos al usuario logueado desde el contexto
   
  const detectType = (value: any): string => {
    
    if (typeof value === 'string') {
      return 'string';
    } else if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      return 'object';
    } 
    else if (value !== null && typeof value === 'object' && Array.isArray(value)) {
      return 'objectArray';
    }else {
      return 'other';
    }
  };

  const generateUniqueId = (): string => {
    return `id-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  };

  
  return (
    <div className="space-y-2 m-5 border shadow-sm rounded-lg bg-slate-50 animate-fadeIn">

      {(detectType(documents) == 'string' )&&(
          <div key={generateUniqueId()} className="p-4 "> 
            <p className="mt-2 text-sm text-gray-600 whitespace-pre-line"> 
              {documents} 
            </p>
          </div> 
        )
      }

      {(detectType(documents) == 'objectArray' )&&documents.map((doc:any, index:any) => (
        <div key={index} className="p-4 "> 
          <h2 className="text-lg font-semibold text-gray-700 border-b">
             
            {myDocs&&myDocs.find( (nameObj:any) => nameObj.file_id === doc.metadata.file_id )?.filename} 
            {userProject.docs.find( (nameObj:any) => nameObj.file_id === doc.metadata.file_id)?.name}
          </h2> 
          <p className="mt-2 text-sm text-gray-600 whitespace-pre-line">
          
          {doc.page_content}
        
          </p>
        </div>
      ))}
    </div>
  );
};

export default Citations;